import { Ng2StateDeclaration } from "@uirouter/angular";
import { PersonalNotificationComponent } from "./components/personal-notification/personal-notification.component";

export const personalNotificationState: Ng2StateDeclaration = {
  name: "personal",
  url: "/user-notification-settings",
  data: { requiresAuth: true },
  component: PersonalNotificationComponent,
};

export const MANAGE_NOTIFICATION_STATES = [personalNotificationState];
